import trI18n from '@/common/utils/trI18n';

export const JOB_LIST = [
    { id: 1, value: trI18n('LABEL-MANAGER-OFFICER') },
    { id: 2, value: trI18n('LABEL-GENERAL- MANAGER') },
    { id: 3, value: trI18n('LABEL-MANAGER') },
    { id: 4, value: trI18n('LABEL-SECTION-CHIEF-MANAGER') },
    { id: 5, value: trI18n('LABEL-GENERAL-CHIEF-CHIEF') },
    { id: 6, value: trI18n('LABEL-GENERAL-EMPLOYEE') },
];

export const INDUSTRY = [
    { id: 1, value: trI18n('LABEL-INFORMATION-SERVICE') },
    { id: 2, value: trI18n('LABEL-COMMUNICATION-MEDIA') },
    { id: 3, value: trI18n('LABEL-CHEMICAL-PETROLEUM-COAL-PRODUCTS') },
    { id: 4, value: trI18n('LABEL-FOOD-PRODUCTS') },
    { id: 5, value: trI18n('LABEL-ELECTRICITY-MECHANICAL') },
    { id: 6, value: trI18n('LABEL-STEEL-METAL') },
    { id: 7, value: trI18n('LABEL-TRANSPORTATION-EQUIMENT') },
    { id: 8, value: trI18n('LABEL-PHARMACEUTICAL') },
    { id: 9, value: trI18n('LABEL-OTHER-MANUFACTURING') },
    { id: 10, value: trI18n('LABEL-SERVICE') },
    { id: 11, value: trI18n('LABEL-CONSULTING') },
    { id: 12, value: trI18n('LABEL-CONSTRUCTION') },
    { id: 13, value: trI18n('LABEL-FINANCE') },
    { id: 14, value: trI18n('LABEL-INSURANCE') },
    { id: 15, value: trI18n('LABEL-RETAIL-WHOLESALE') },
    { id: 16, value: trI18n('LABEL-REAL-ESTATE') },
    { id: 17, value: trI18n('LABEL-WAREHOUSING-TRANSPORTATION-RELATED') },
    { id: 18, value: trI18n('LABEL-ELECTRICITY-GAS') },
    { id: 19, value: trI18n('LABEL-MEDICAL-INSTITUTION') },
    { id: 20, value: trI18n('LABEL-GOVERMENT-OFFICE') },
    { id: 21, value: trI18n('LABEL-LOCAL-GOVERNMENT') },
    { id: 22, value: trI18n('LABEL-EDUCATION') },
    { id: 23, value: trI18n('LABEL-OTHERS') },
];

export const DEFAULT_GENERAL_USER = "5";

export const STATUS_CONTRACT = {
    TRIAL: {
        LABEL_TRIAL: trI18n('CM-CONTRACT-STATUS-TRIAL'),
        STATUS: 'trial'
    },
    ACTIVE: {
        LABEL_TRIAL: trI18n('CM-CONTRACT-STATUS-ACTIVE'),
        STATUS: 'active'
    },
    CANCELLED: {
        LABEL_TRIAL: trI18n('CM-CONTRACT-STATUS-CANCELLED'),
        STATUS: 'cancelled'
    },
    EXPIRED: {
        LABEL_TRIAL: trI18n('CM-CONTRACT-STATUS-EXPIRED'),
        STATUS: 'expired'
    },
}
